<template lang="pug">
  b-container.content-wrap(fluid :class="{ 'is-mobile': isMobile }")
    b-row.mb-2
      b-col.page-wrap(cols="12")
        div.page-header(slot="header")
          b-container.d-flex.justify-content-between(fluid)
            span.page-title {{$t('management_page.user_remote_request_approval')}}

    b-row.search-form
      b-col.mmb-10(cols="12" lg="2")
        b-form-select(v-model="form.date_type" :options="selectOptions.date" size="sm")
      b-col.mmb-10(cols="6" lg="2")
        b-form-datepicker(
          v-model="range.start"
          :bootstrap-styling="true"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="search"
        )
      b-col.mmb-10(cols="6" lg="2")
        b-form-datepicker(
          v-model="range.end"
          :bootstrap-styling="true"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="search"
        )
      b-col.mmb-10(cols="12" lg="4")
        b-input-group
          b-input-group-prepend
            b-form-select.mr-2(v-model="form.search_key" :options="selectOptions.list" size="sm" @change="changeSearchSelect")
          b-form-input.mr-2(v-if="selectInput.type === 'keyword'" v-model="form.search_value" size="sm" @keyup.enter="search")
          b-form-select.mr-2(v-if="selectInput.type === 'select'" v-model="form.search_value" :options="selectInput.list" size="sm")
          b-input-group-append
            b-btn(size="sm" @click="search") {{$t('search')}}

      b-col.right-btns
        b-btn.ml-2.view-mode-button(size="sm", :disabled="excelLoaded" @click="downloadExcel")
          img.mr-1(:src="`${AppState.Path.image}/icons/excel-icon.svg`" style="height: 0.9rem; vertical-align: middle;")
          span(v-if="!excelLoaded") {{$t('excel_button')}}
          span(v-else) Download...
    
    b-card.table-card
      b-table(
        ref="agentTable"
        :fields="tableData.fields"
        :items="fetchList"
        :current-page="tableData.pagination.current"
        :per-page="tableData.pagination.limit"
        :empty-text="$t('no-content')"
        tbody-class="lmm-table-body"
        sort-by="create_time"
        :sort-desc="true"
        show-empty
        responsive
      )
        //- body
        template(v-slot:cell(create_time)="row")
          span {{ row.item.create_time | moment('YY-MM-DD HH:mm') }}
        
        template(v-slot:cell(start_time)="row")
          span {{ row.item.start_time | moment('YY-MM-DD HH:mm') }}
        
        template(v-slot:cell(end_time)="row")
          span {{ row.item.end_time | moment('YY-MM-DD HH:mm') }}

        template(v-slot:cell(requester_name)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.user_fk}}") {{row.item.requester_name}}

        template(v-slot:cell(part_name)="row")
          b-btn(v-if="user.type !== 'SubManager'" variant="link", :to="{name: 'user-edit-department', params: {id: row.item.part_pk}}") {{row.item.part_name}}
          span(v-else) {{row.item.part_name}}

        template(v-slot:cell(flag_auto_record)="row")
          switches.lmm-switch(
            v-model="row.item.flag_auto_record",
            theme="bootstrap",
            :color="row.item.flag_auto_record ? 'warning' : 'default'"
          )
          
        template(v-slot:cell(post_approval)="row")
          span {{ kindFilter(row.item.post_approval) }}

        template(v-slot:cell(approver_name)="row")
          b-btn(variant="link" @click="openDialogApprovalLineInfo(row.item)") {{row.item.approver_name}}
        
        template(v-slot:cell(btn)="row")
          b-button.d-inline-flex(size="sm" variant="primary" :class="{ 'request' : row.item.permission_flag === 0 }" :disabled="row.item.permission_flag !== 1" @click="openDialogApprovalRequest(row.item)") 결재

    //- pagination
    .pagination-wrap
      div
        b-form-select(
          size="sm"
          v-model="tableData.pagination.limit"
          :options="tableData.pagination.perOptions"
        )
      b-pagination(
        size="sm"
        v-model="tableData.pagination.current"
        :total-rows="tableData.pagination.total"
        :per-page="tableData.pagination.limit"
        class="my-0 float-right"
      )

    dialog-approval-request(:show.sync="showDialogApprovalRequest" :title="String($t('management_page.user_remote_request_approval'))" :form="requestForm" @complate="refreshList")
    dialog-approval-line-info(:show.sync="showDialogApprovalLineInfo" :form="approvalLineForm")
</template>

<script>
import { ManagementAPI, GetMgridAPI } from "@/api"

import DialogApprovalRequest from "../components/dialogApprovalRequest.vue"
import DialogApprovalLineInfo from "../components/dialogApprovalLineInfo.vue"
import Switches from "vue-switches"
import _ from "lodash"
import moment from "moment"
import { user } from "@/api/access"

export default {
  components: {
    DialogApprovalRequest,
    DialogApprovalLineInfo,
    Switches,
  },
  computed: {
    selectInput() {
      return _.find(this.selectOptions.list, { value: this.form.search_key })
    },
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
    kindFilter(value) {
      return (value) => {
        switch (value) {
          case 0:
            return this.$t('prior')
          case 1:
            return this.$t('post')
          case 2:
            return this.$t('exception')
          default:
            return "-"
        }
      }
    },
  },
  data() {
    return {
      user: user(),
      range: {
        start: moment()
          .add(-14, "days")
          .toDate(),
        end: moment().toDate(),
      },
      form: {
        date_type: "create_time",
        search_key: "requester_name",
        search_value: "",
      },
      selectOptions: {
        date: [
          { text: this.$t('application_datetime'), value: "create_time" },
          { text: this.$t('start_datetime'), value: "start_time" },
          { text: this.$t('end_datetime'), value: "end_time" },
        ],
        list: [
          { text: this.$t('applicant'), value: "requester_name", type: "keyword" },
          { text: this.$t('department'), value: "part_name", type: "keyword" },
          { text: this.$t('applicant'), value: "approver_name", type: "keyword" },
          {
            text: this.$t('category'),
            value: "post_approval",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: this.$t('prior'), value: "0" },
              { text: this.$t('post'), value: "1" },
              { text: this.$t('exception'), value: "2" },
            ],
          },
        ],
      },
      excelLoaded: false,
      excelLink: null,

      allSelected: false,
      allChecked: [],
      tableData: {
        fields: [
          {
            key: "check",
            label: "",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: false,
            thStyle: { width: "1%" },
          },
          { key: "create_time", label: this.$t('application_datetime'), sortable: true, thStyle: { minWidth: "170px" }, tdClass: "text-nowrap" },
          { key: "start_time", label: this.$t('start_datetime'), sortable: true, thStyle: { minWidth: "170px" }, tdClass: "text-nowrap" },
          { key: "end_time", label: this.$t('end_datetime'), sortable: true, thStyle: { minWidth: "170px" }, tdClass: "text-nowrap" },
          { key: "requester_name", label: this.$t('applicant'), sortable: true, thStyle: { minWidth: "100px" }, tdClass: "text-nowrap" },
          { key: "part_name", label: this.$t('department'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
          { key: "approver_name", label: this.$t('approver'), sortable: true, thStyle: { minWidth: "100px" }, tdClass: "text-nowrap" },
          { key: "post_approval", label: this.$t('category'), sortable: true, thStyle: { minWidth: "80px" }, tdClass: "text-nowrap" },
          { key: "reason", label: this.$t('application_reason'), sortable: true, thStyle: { minWidth: "200px" }, tdClass: "text-nowrap" },
          { key: "btn", label: this.$t('approval_process'), thClass: "text-center", thStyle: { minWidth: "80px" }, tdClass: "text-nowrap text-center" },
        ],
        list: [],
        pagination: {
          by: "create_time",
          limit: 24,
          offset: 0,
          order: "desc",

          date_type: "create_time",
          start_date: moment()
            .add(-14, "days")
            .format("YYYY-MM-DD"),
          end_date: moment().format("YYYY-MM-DD"),

          request_type: 1,

          search_key: "",
          search_value: "",
          search_mode: "pagination",

          total: 1,
          current: 1,
          perOptions: [
            { value: 12, text: "12" },
            { value: 24, text: "24" },
            { value: 36, text: "36" },
          ],
        },
      },

      complateList: [],

      showDialogApprovalRequest: false,
      requestForm: {},

      showDialogApprovalLineInfo: false,
      approvalLineForm: {
        type: 0,
        type_pk: null,
      },
    }
  },
  methods: {
    fetchList(ctx) {
      if (ctx.sortBy === "") return

      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit

      let params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,

        start_date: this.tableData.pagination.start_date,
        end_date: this.tableData.pagination.end_date,

        request_type: this.tableData.pagination.request_type,

        date_type: this.tableData.pagination.date_type,
        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",
      }

      return ManagementAPI.management.get("remote", { params }).then(res => {
        const { objects, meta, status } = res.data
        if (status !== 200) {
          this.$awn.warning(String(this.$awn.warning(this.$t('toasts_message.data_fetch_failed'))))
          return []
        }

        this.tableData.list = objects
        this.tableData.pagination.total = meta.total_count
        
        return this.tableData.list
      })
    },
    search() {
      this.tableData.pagination.start_date = moment(this.range.start).format("YYYY-MM-DD")
      this.tableData.pagination.end_date = moment(this.range.end).format("YYYY-MM-DD")
      this.tableData.pagination.current = 1
      this.tableData.pagination.date_type = this.form.date_type
      this.tableData.pagination.search_key = this.form.search_key
      this.tableData.pagination.search_value = this.form.search_value
      this.$refs.agentTable.refresh()
    },
    openDialogApprovalLineInfo(item) {
      this.type_pk = item.type_pk
      this.showDialogApprovalLineInfo = true
    },
    openDialogApprovalRequest(item) {
      this.requestForm = item
      this.showDialogApprovalRequest = true
    },

    async downloadExcel() {
      this.excelLoaded = true
      const params = await this.fetchExcel()
        .then(params => {
          //전송용 임시 폼 엘리먼트 생성
          var form = document.createElement("form")
          form.method = "post"
          form.action = "/download/excel.html" // /download/excel.html을 통해 DownloadExcelFileAPI호출

          // 엑셀 생성에 필요한 필터된 데이터를 폼에 추가
          let jsonData = {...params, language: this.$i18n.locale}
          var input = document.createElement("input")
          input.type = "hidden"
          input.name = "jsondata"
          input.value = JSON.stringify(jsonData)
          form.appendChild(input)

          // body에 폼 추가 및 제출 그 후 제거
          document.body.appendChild(form)
          form.target = "_blank"
          form.submit()
          document.body.removeChild(form)

          this.excelLoaded = false
        })
        .catch(err => {
          this.excelLoaded = false
          alert(String(this.$t('toasts_message.no_data_to_download_excel')))
        })
    },

    async fetchExcel() {
      let params = {
        by: this.tableData.pagination.by,
        limit: 0,
        offset: 0,
        order: this.tableData.pagination.order,

        start_date: this.tableData.pagination.start_date,
        end_date: this.tableData.pagination.end_date,

        request_type: this.tableData.pagination.request_type,

        date_type: this.tableData.pagination.date_type,
        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",
      }

      if (this.tableData.pagination.total < 1) {
        throw new Error(String(this.$t('no_data_available')))
      }
      const list = await ManagementAPI.management.get("remote", { params })

      const excelParams = list.data
      excelParams.excel_doc_title = this.$t('management_page.user_remote_request_approval')

      const { data } = await GetMgridAPI.get("")
      const excelParams_for_download = {
        api: excelParams.api,
        excel_doc_title: "",
        pagename: "",
        mgrid: data.objects.mgrid,
        objects: this.downloaded_excel_data_form(excelParams.objects),
      }
      excelParams_for_download.pagename = "userremote_approval"
      excelParams_for_download.excel_doc_title = this.$t('management_page.user_remote_request_approval')

      return excelParams_for_download
    },
    downloaded_excel_data_form(input) {
      let originalLocale = this.$i18n.locale
      this.$i18n.locale = "ko"
      
      //input = excelParams.objects
      let post_approval = {
        "0": this.$t('prior'),
        "1": this.$t('post'),
        "2": this.$t('exception'),
      }
      let output = []
      for (let index = 0; index < input.length; index++) {
        let obj = {
          [this.$t('application_datetime')]: input[index]["create_time"],
          [this.$t('start_datetime')]: input[index]["start_time"],
          [this.$t('end_datetime')]: input[index]["end_time"],
          [this.$t('applicant')]: input[index]["requester_name"],
          [this.$t('department')]: input[index]["part_name"],
          [this.$t('approver')]: input[index]["approver_name"],
          [this.$t('category')]: post_approval[input[index]["post_approval"]],
          [this.$t('application_reason')]: input[index]["reason"],
        }
        let obj2 = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, this.nullcheck(value)]))
        output.push(obj2)
      }
      this.$i18n.locale = originalLocale
      return output
    },
    nullcheck(input) {
      return input == null ? "-" : input
    },
    Date_time_split(input) {
      let return_array = []
      if (input != "-") {
        let input_array = input.split("T")
        return_array[0] = input_array[0]
        return_array[1] = input_array[1]
          .split(":")
          .slice(0, 2)
          .join(":")
      } else {
        return_array[0] = "-"
        return_array[1] = "-"
      }
      return return_array
    },
    changeSearchSelect() {
      if (this.selectInput.type === "select") {
        this.form.value = this.selectInput.list[0].value
      } else {
        this.form.value = ""
      }
    },

    refreshList() {
      this.$refs.agentTable.refresh()
    },
  },
}
</script>

<style lang="scss" scoped>
.request {
  &:disabled {
    background-color: #ccc;
    border-color: #ccc;
  }
}
</style>
